import {Camera, WifiOff, Wifi} from 'lucide-react';
import React, {useEffect, useState, useRef, useContext} from 'react';
import styles from './TeleOp.module.css';
import {SwapMainAppContext} from "../../context/SwapMainAppContext";

const VideoFeed = ({robotId, isConnected, isControlConnected, isTeleOpMode, videoSrc, videoSrc2, global_live = false}) => {
    const {livePaused, videoId} = useContext(SwapMainAppContext);
    
    // Local state to handle swapped videos
    const [isSwapped, setIsSwapped] = useState(false);
    const [showPlayButton, setShowPlayButton] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    const iframeRef = useRef(null);
    
    // Determine which video to show in main and small positions
    const mainVideoSrc = isSwapped ? videoSrc2 : videoSrc;
    const smallVideoSrc = isSwapped ? videoSrc : videoSrc2;
    
    // Detect mobile device and handle autoplay
    useEffect(() => {
        const checkMobile = () => {
            const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                           window.innerWidth <= 768;
            setIsMobile(mobile);
            
            if (mobile && !isControlConnected) {
                // On mobile, show play button after a delay if video doesn't auto-start
                const timer = setTimeout(() => {
                    setShowPlayButton(true);
                    setIsVideoPlaying(false);
                }, 2000);
                
                // Check for video playing after another delay
                const playCheckTimer = setTimeout(() => {
                    if (iframeRef.current) {
                        // Assume video is playing if no play button is shown after 4 seconds
                        setIsVideoPlaying(!showPlayButton);
                    }
                }, 4000);
                
                return () => {
                    clearTimeout(timer);
                    clearTimeout(playCheckTimer);
                };
            } else {
                // On desktop, assume video autoplays
                setIsVideoPlaying(true);
            }
        };
        checkMobile();
        
        // Reset play button when switching between video modes
        if (isControlConnected) {
            setShowPlayButton(false);
            setIsVideoPlaying(true);
        }
    }, [isControlConnected, showPlayButton]);
    
    const handleSwap = () => {
        setIsSwapped(!isSwapped);
    };
    
    const handlePlayClick = () => {
        setShowPlayButton(false);
        setIsVideoPlaying(true);
        // Reload iframe to trigger autoplay again
        if (iframeRef.current) {
            const currentSrc = iframeRef.current.src;
            iframeRef.current.src = '';
            iframeRef.current.src = currentSrc;
        }
    };

    return (
        <div className={`${styles.videoContainer} ${global_live && styles.globalvideocontainer} ${!global_live && styles.notGlobalvideocontainer}`}>
            <div className={styles.videoContainerInner}>
                <div className={styles.liveIndicatorContainer}>
                    {livePaused[robotId]? <div className={styles.liveIndicator2}>
                        <span className={styles.pausedDot}></span>
                        Paused - We will be back soon
                    </div>: <div className={styles.liveIndicator}>
                        <span className={styles.liveDot}></span>
                        LIVE - Room Overview
                    </div>
                    }
                </div>

                {/*<div className={styles.connectionStatus}>*/}
                {/*{isConnected ? (*/}
                {/*    <Wifi className={styles.connectedIcon} size={20} />*/}
                {/*) : (*/}
                {/*    <WifiOff className={styles.disconnectedIcon} size={20} />*/}
                {/*)}*/}
                {/*{isTeleOpMode && (*/}
                {/*    <>*/}
                {/*        <span style={{ marginLeft: '10px' }}>Controls: </span>*/}
                {/*        {isControlConnected ? (*/}
                {/*            <Wifi className={styles.connectedIcon} size={20} />*/}
                {/*        ) : (*/}
                {/*            <WifiOff className={styles.disconnectedIcon} size={20} />*/}
                {/*        )}*/}
                {/*    </>*/}
                {/*)}*/}
                {/*</div>*/}

                {/*only show low lentency video when controlled*/}
                {(!isControlConnected) ? (
                    <div style={{position: 'relative', width: '100%', height: '100%'}}>
                        <iframe
                            ref={iframeRef}
                            className={styles.videoFeed}
                            width="100%"
                            height="100%"
                            src={`https://www.youtube.com/embed/${videoId[robotId] || ''}?autoplay=1&mute=1&controls=0&disablekb=1&iv_load_policy=3&modestbranding=1&rel=0&showinfo=0&fs=0&cc_load_policy=0&playsinline=1&loop=1&enablejsapi=0&origin=${window.location.origin}&start=0&end=0`}
                            title="YouTube Live Stream"
                            frameBorder="0"
                            allow="autoplay; encrypted-media; accelerometer; gyroscope; picture-in-picture"
                            allowFullScreen
                            style={{width: '100%', height: '100%', objectFit: 'contain', pointerEvents: isMobile ? 'auto' : 'none'}}
                        />

                        
                        {/* Only show overlay on desktop to prevent clicks */}
                        {!isMobile && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                backgroundColor: 'transparent',
                                pointerEvents: 'none',
                                zIndex: 1
                            }}></div>
                        )}
                    </div>
                ) : mainVideoSrc ? (
                    <div style={{position: 'relative', width: '100%', height: '100%'}}>
                        <img
                            src={mainVideoSrc}
                            alt="Live camera feed"
                            className={styles.videoFeed}
                            style={{width: '100%', height: '100%', objectFit: 'contain'}}
                        />
                        {isControlConnected && smallVideoSrc && (
                            <div className={styles.secondVideoFeedContainer}>
                                 <img
                                    src={smallVideoSrc}
                                    alt="Second camera feed"
                                    className={styles.secondVideoFeed}
                                    onClick={handleSwap}
                                    style={{cursor: 'pointer'}}
                                />
                                <div className={styles.secondVideoFeedCaption}>
                                    Robot View
                                </div>
                            </div>
                           
                        )}
                    </div>
                ) : (
                    <div className={styles.videoPlaceholder}>
                        <Camera className={styles.cameraIcon} size={48}/>
                        <p className={styles.streamStatus}>Room view camera</p>
                        <p className={styles.streamSubtext}>
                            {isConnected ? 'Waiting for video stream...' : 'Connecting to camera server...'}
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};
export default VideoFeed;
